import { Dispatch } from 'redux';
import { Action, AvailableModalActions } from '../store';
import { pepperApi } from 'modules/cm/api';
import { setModalScreen, setSendErrors, setSendStart, setSendSuccess, setValidationErrors } from '../actions';
import closePepperContext from './closePepperContext';
import { guard, PepperSendError } from '../../errors';
import { PlainResponseError } from 'utils/api/error/ResponseError';
import * as sharedCaseActions from 'modules/cm/store/sharedActions';
import { refreshCase } from '../../../../../store/cases/actions';

const sendDataToPepper = () => {
  return async (dispatch: Dispatch<Action>, getState: any) => {
    const api = pepperApi(getState().currentCase.data.case.identifier);
    const state = getState().currentCase;

    dispatch(setSendStart());

    try {
      const { data } = await api.sendToPepper();

      if (data.pepperStatus === 'ERROR' && data.data) {
        throw new PepperSendError(data.data);
      }

      await dispatch(setSendSuccess());
      await sharedCaseActions.setPepperUploadDate(data.pepperUploadDate)(dispatch as Dispatch);
      await closePepperContext()(dispatch, getState);
      await sharedCaseActions.setCaseErrors(null)(dispatch as Dispatch);
      await refreshCase(state.data!.case.identifier)(dispatch as Dispatch, getState);
    } catch (e) {
      if (guard.isPepperValidationError(e)) {
        dispatch(setSendErrors([]));
        await sharedCaseActions.setCasePepperError(e.getErrors())(dispatch as Dispatch);
        dispatch(setValidationErrors(e.getErrors()));
        dispatch(setModalScreen(AvailableModalActions.VALIDATE_FAILED));
      } else if (guard.isPepperSendError(e)) {
        await dispatch(setSendErrors(e.getErrors()));
        await dispatch(setModalScreen(AvailableModalActions.SEND_ERRORS));
      } else if (e instanceof PlainResponseError) {
        await dispatch(setSendErrors([e.getErrorMessage()]));
        await dispatch(setModalScreen(AvailableModalActions.SEND_ERRORS));
      } else {
        await dispatch(setSendErrors([]));
        dispatch(setModalScreen(AvailableModalActions.GENERAL_ERROR));
      }
    }
  };
};

export default sendDataToPepper;
